document.addEventListener('DOMContentLoaded', function () {
	document.body.addEventListener('click', (event) => {
		if (!event.target.matches('.like-toggle') && !event.target.closest('.like-toggle')) return;
		event.target.closest('div').querySelectorAll('a').forEach(function (element) {
			element.classList.toggle('d-none');
		});
	});
});

